import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { getDateWithFormat } from '../../helpers/Utils';
import { getRequest } from '../../helpers/api';
import {
  gAPI_Conversations_list,
  gAPI_Conversations_By_Id,
} from '../../constants/APIs';
import { AxiosAPI } from '../../helpers/AxiosAPI';

import { CHAT_LIST_GET_LIST, CHAT_GET } from '../actions';

import {
  getChatListSuccess,
  getChatListError,
  getChatSuccess,
  getChatError,
} from './actions';

import chatListData from '../../data/chat.list.json';

const getChatListRequest = async ({ pid, items, offset }) => {
  return await new Promise((success, fail) => {
    setTimeout(() => {
      // getRequest(`/conversations?gid=&pid=${pid}&aid=&df=&ft=&tags=&offset=${offset}&limit=${items}`)
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Conversations_list}?gid=&pid=${pid}&aid=&df=&ft=&tags=&offset=${offset}&limit=${items}&facebookSenderName=`,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          const chats = data;
          const currentUser = chats[0];
          success({ chats, currentUser });
        });
    });
  })
    .then((response) => response)
    .catch((error) => error);
};

const getChatRequest = async (pid) => {
  //console.log(pid);
  //let pid1 = '0dac1c91-206c-402d-b9ad-d9e4da355887';
  // return await new Promise((success, fail) => {
  //   setTimeout(() => {
  //     // const data = fetch("http://52.168.108.59/conversations/0dac1c91-206c-402d-b9ad-d9e4da355887")
  //     .then(function (response) {
  //       console.log('ddd', response.json());
  //         return response.json();
  //       })
  //       .then(function (data) {
  //         console.log('ddd', data);
  //         const chat = data;
  //         success({ chat });
  //       })
  //     })
  //   })
  let AUTHORITY_SERVER = '';
  if (window.location.hostname.toLowerCase().includes('sabre'))
    AUTHORITY_SERVER = process.env.REACT_APP_SABRE_AUTHORITY_SERVER;
  else if (window.location.hostname.toLowerCase().includes('synxis'))
    AUTHORITY_SERVER = process.env.REACT_APP_SYNXIS_AUTHORITY_SERVER;
  else if (window.location.hostname.toLowerCase().includes('myma.ai'))
    AUTHORITY_SERVER = process.env.REACT_APP_MYMA_AUTHORITY_SERVER;
  else AUTHORITY_SERVER = process.env.REACT_APP_AUTHORITY_SERVER;

  let GROUP_ID = JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
    )
  ).profile.nickname;
  return await AxiosAPI({
    methhod: 'get',
    url: `${gAPI_Conversations_By_Id}/${pid.replace(
      '|livechat',
      ''
    )}?gid=${GROUP_ID}`,
  })
    .then((response) => response.data)
    .catch((error) => error);
};

function* getChatListItems({ pid, items, offset }) {
  try {
    const response = yield call(getChatListRequest, pid, items, offset);
    //console.log(response);
    const { chats, currentUser } = response;
    const loadchats = chats;
    yield put(getChatListSuccess(chats, currentUser, loadchats));
  } catch (error) {
    yield put(getChatListError(error));
  }
}

function* getChat({ payload }) {
  try {
    const response = yield call(getChatRequest, payload);
    yield put(getChatSuccess(response));
  } catch (error) {
    yield put(getChatError(error));
  }
}

export function* watchGetList() {
  yield takeEvery(CHAT_LIST_GET_LIST, getChatListItems);
  yield takeEvery(CHAT_GET, getChat);
}

export default function* rootSaga() {
  yield all([fork(watchGetList)]);
}
